import { observer } from 'mobx-react';
import { QuoteTypeStore } from '../../../stores/quoteTypeStore';
import { Divider, Grid, Typography } from '@material-ui/core';
import { ONE_PAYMENT, TWO_PAYMENTS } from '@roc/feature-utils';
import { FormStore } from '@roc/feature-app-core';
import { createRadioField } from '../../../components/temp/componentBuiderTemp';
import { formatCurrency } from '@roc/ui/utils';
import { useEffect, useState } from 'react';

interface PrefligthSecondAppraisalModalProps {
  store: QuoteTypeStore;
}

export const PrefligthSecondAppraisalModal = observer(
  ({ store }: PrefligthSecondAppraisalModalProps) => {

    const secondaryAppraisalOptions = [
      { label: `One payment for both Appraisals: <b>${formatCurrency(store.secondAppraisalPricingData?.totalCost)}</b>`, value: ONE_PAYMENT },
      { label: `Two separate payments for the appraisals: one for <b>${formatCurrency(store.secondAppraisalPricingData.firstAppraisalCost)}</b> then <b>${formatCurrency(store.secondAppraisalPricingData.secondAppraisalCost)}</b>`, value: TWO_PAYMENTS },
    ];

    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body1">
              We have replaced our CDA/ARR Secondary Valuation with a more robust method. The cost, timeline, and rules remain roughly the same – $150, a few days, and 10% variance allowance. Be sure to thoroughly document the prior renovation work completed with a full scope of work description and preferably some before/after pictures.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <SecondAppraisal store={store.preflightStore.secondAppraisalFormStore} options={secondaryAppraisalOptions} />
          </Grid>
          <Grid container item xs={12} style={{ backgroundColor: '#FAE694' }} justifyContent={'space-between'}>
            <Typography variant="body1">
              Total Fee:
            </Typography>
            <Typography variant="body1">
              {formatCurrency(store.secondAppraisalPricingData?.totalCost)}
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  }
);

const SecondAppraisal = observer(({ store, options }: {
  store: FormStore, options: Array<{ value: any; label: string; }>
}) => {
  return (
    <>
      {createRadioField({
        label: 'Payment Options',
        fieldName: 'secondAppraisal',
        testId: 'secondAppraisal',
        store,
        options: options,
        row: false,
        standaloneLabel: false,
        addMarkForRequiredFields: true,
        isRequired: true,
        needHtml: true,
        formControlStyle: { gap: "4px" }
      })}
    </>
  );
});